import { render, staticRenderFns } from "./VueCarousel.vue?vue&type=template&id=f3720f4a&scoped=true&lang=pug&"
import script from "./VueCarousel.vue?vue&type=script&lang=js&"
export * from "./VueCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VueCarousel.vue?vue&type=style&index=0&id=f3720f4a&scoped=true&lang=css&"
import style1 from "./VueCarousel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3720f4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
